import { contactInfo } from '@/mocks/homeData';

export default function ContactSection() {
  return (
    <section id="contact" className="py-12 md:py-16 bg-background-50">
      <div className="section-container">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="section-title">联系我们</h2>
          <p className="section-subtitle">{contactInfo.subtitle}</p>
        </div>

        <div className="max-w-2xl mx-auto bg-background-50 rounded-2xl border border-background-200/70 p-6 md:p-8">
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
            {contactInfo.description}
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <div className="flex-1 flex items-center gap-3 p-4 bg-background-100 rounded-xl border border-background-200/50">
              <div className="w-10 h-10 rounded-lg bg-primary-50 flex items-center justify-center flex-shrink-0">
                <i className="ri-mail-line text-primary-600 text-lg"></i>
              </div>
              <div>
                <p className="text-xs text-foreground-500">爆料投稿邮箱</p>
                <p className="text-sm font-medium text-foreground-900">{contactInfo.email}</p>
              </div>
            </div>
            <div className="flex-1 flex items-center gap-3 p-4 bg-background-100 rounded-xl border border-background-200/50">
              <div className="w-10 h-10 rounded-lg bg-accent-50 flex items-center justify-center flex-shrink-0">
                <i className="ri-wechat-line text-accent-600 text-lg"></i>
              </div>
              <div>
                <p className="text-xs text-foreground-500">商务合作微信</p>
                <p className="text-sm font-medium text-foreground-900">{contactInfo.wechat}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}